import React from 'react'
import { Radio as FormilyRadio } from './radio'
import { createBehavior, createResource } from '@designable/core'
import { DnFC } from '@designable/react'
import { createFieldSchema } from '../Field'
import { AllSchemas } from '../../schemas'
import { AllLocales } from '../../locales'
import { Layout } from 'antd'
import {
  DataSourceSetter,
} from '@/pages/MainPage/frames/Formily/src/setters'

export const Radio: DnFC<React.ComponentProps<typeof FormilyRadio>> = FormilyRadio

Radio.Behavior = createBehavior({
  name: 'Radio.Group',
  extends: ['Field'],
  selector: (node) => node.props['x-component'] === 'Radio.Group',
  designerProps: {
    propsSchema: createFieldSchema({
      type: 'object',
      properties: {
        options: {
          title:'配置可选项',
          "x-decorator": 'FormItem',
          "x-component": DataSourceSetter
        },
      },
    }),
  },
  designerLocales: {
    'zh-CN': {
      title: '单选框',
    }
  },
})

Radio.Resource = createResource({
  icon: 'RadioGroupSource',
  elements: [
    {
      componentName: 'Field',
      props: {
        type: 'string | number',
        title: 'Radio Group',
        'x-decorator': 'FormItem',
        'x-component': 'Radio.Group',
        'x-decorator-props': {
          layout: 'vertical',
        },
        'x-component-props': {
          options: [
            { label: '选项1', value: '1' },
            { label: '选项2', value: '2' },
          ],
        }
      },
    },
  ],
})
